export default "__VITE_ASSET__DeHUZGi4__"